(function () {
	/* PERF 15SEP2026: reescrito sin jQuery */
	const onToggle = function () {
		const parent = this.parentElement;
		const items = this.closest(".banner-with-popup__items");
		const answer = this.nextElementSibling;

		if (!parent.classList.contains("active")) {
			if (items) {
				items.querySelectorAll(".banner-with-popup__item.active").forEach((el) => el.classList.remove("active"));
				items.querySelectorAll(".banner-with-popup__answer").forEach((el) => window.hmpSlideUp(el, 300));
			}
			parent.classList.add("active");
			window.hmpSlideDown(answer, 300);
		} else {
			parent.classList.remove("active");
			window.hmpSlideUp(answer, 300);
		}
	};

	const initToggles = () => {
		document.querySelectorAll(".banner-with-popup__toggle").forEach((toggle) => {
			toggle.removeEventListener("click", onToggle);
			toggle.addEventListener("click", onToggle);
		});
	};

	const startGallerySlideshow = (images) => {
		if (images.length <= 1) return;
		const gallery = images[0].closest(".banner-with-popup__gallery");
		if (!gallery || gallery._hmpSlideshow) return;
		gallery._hmpSlideshow = true;

		const speed = Number(window.hmpData(gallery, "speed")) * 1000 || 4000;
		let currentImageIndex = 0;
		const fadeSpeed = 1000;

		window.hmpFadeIn(images[currentImageIndex], fadeSpeed);

		setInterval(function () {
			const nextImageIndex = (currentImageIndex + 1) % images.length;
			window.hmpFadeOut(images[currentImageIndex], fadeSpeed);
			window.hmpFadeIn(images[nextImageIndex], fadeSpeed);
			currentImageIndex = nextImageIndex;
		}, speed);
	};

	const initGallery = () => {
		document.querySelectorAll(".banner-with-popup").forEach((item) => {
			const images = Array.from(item.querySelectorAll(".banner-with-popup__gallery--image-wrapper"));
			const targets = item.querySelectorAll(".observe-me");

			if (targets.length > 0) {
				const observer = new IntersectionObserver((entries, obs) => {
					entries.forEach((entry) => {
						if (!entry.isIntersecting) return;
						const cls = entry.target.classList;
						cls.add("is-inview");
						obs.unobserve(entry.target);
						setTimeout(() => {
							cls.remove("is-inview");
							cls.remove("observe-me");
							startGallerySlideshow(images);
						}, 600);
					});
				}, { root: null, rootMargin: "0px", threshold: 0.1 });
				targets.forEach((t) => observer.observe(t));
			} else {
				startGallerySlideshow(images);
			}
		});
	};

	const boot = () => { initToggles(); initGallery(); };
	boot();
	document.addEventListener("DOMContentLoaded", boot);
	document.addEventListener("shopify:section:load", boot);
})();
